/* eslint-disable no-unused-vars */
export enum EstructuraSitio {
  DESTACADOS = 'destacados',
  EXPERIENCIAS = 'experiencias',
  LOCACIONES = 'locaciones',
  NOVEDADES = 'novedades',
  BENEFICIOS = 'beneficios'
}
